import React, { useState } from 'react';
import { useWorldStore } from '../state/worldStore';
import { adminPanel, AdminClose } from './adminChrome';

// PerformerPanel — on-screen size/height control for the concert-hall performer
// cutout, so the scale can be adjusted VISUALLY (live readout + steppers).
// Shows only while a performer source is set (?perfimg / ?perfvideo). Drives
// worldStore.perfTune, which PerformerImage reads each frame. Copy the values
// to bake them (position height in Interior.jsx, or ?perfh/?perfy).
const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const hasSource = !!params && !!(params.get('perfimg') || params.get('perfvideo'));

const panel = adminPanel({
  position: 'fixed', left: 'max(16px, env(safe-area-inset-left))', bottom: 'max(16px, env(safe-area-inset-bottom))', zIndex: 42,
  width: 194, pointerEvents: 'auto', color: '#d6ecff', font: '12.5px system-ui, sans-serif',
  background: 'rgba(8,14,22,0.86)', border: '1px solid rgba(125,211,255,0.4)', borderRadius: 12,
  padding: '12px 12px 14px', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
});
const btn = {
  pointerEvents: 'auto', background: 'rgba(125,211,255,0.14)', color: '#7dd3ff',
  border: '1px solid rgba(125,211,255,0.4)', borderRadius: 8, padding: '9px 0', cursor: 'pointer',
  font: '600 15px system-ui', textAlign: 'center', userSelect: 'none', flex: 1,
};
const row = { display: 'flex', gap: 6, alignItems: 'center', marginBottom: 8 };
const lab = { fontSize: 10.5, letterSpacing: 1, textTransform: 'uppercase', opacity: 0.7, marginBottom: 4 };

export default function PerformerPanel() {
  const ON = useWorldStore((s) => s.adminTool) === 'performer' || hasSource;
  const perf = useWorldStore((s) => s.perfTune);
  const setPerfTune = useWorldStore((s) => s.setPerfTune);
  const [fine, setFine] = useState(false);
  const [copied, setCopied] = useState(false);
  if (!ON) return null;

  const hStep = fine ? 0.05 : 0.15;
  const yStep = fine ? 0.02 : 0.06;
  const r2 = (v) => Math.round(v * 100) / 100;
  const setH = (v) => setPerfTune({ h: Math.max(0.5, r2(v)) });
  const setY = (v) => setPerfTune({ y: r2(v) });
  const copy = () => {
    navigator.clipboard?.writeText(`position={[0, ${r2(perf.y)}, performZ]} height={${r2(perf.h)}}`)
      .then(() => { setCopied(true); setTimeout(() => setCopied(false), 1200); }).catch(() => {});
  };

  return (
    <div style={panel}>
      <AdminClose />
      <div style={lab}>Performer</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontVariantNumeric: 'tabular-nums', fontSize: 13, marginBottom: 8 }}>
        <span>height <b style={{ color: '#bfe6ff' }}>{perf.h.toFixed(2)}m</b></span>
        <span>feet <b style={{ color: '#bfe6ff' }}>{perf.y.toFixed(2)}</b></span>
      </div>
      <div style={lab}>Size</div>
      <div style={row}>
        <button style={btn} onClick={() => setH(perf.h - hStep)}>− smaller</button>
        <button style={btn} onClick={() => setH(perf.h + hStep)}>taller +</button>
      </div>
      <div style={lab}>Raise / lower</div>
      <div style={row}>
        <button style={btn} onClick={() => setY(perf.y - yStep)}>▼ down</button>
        <button style={btn} onClick={() => setY(perf.y + yStep)}>up ▲</button>
      </div>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, margin: '2px 0 10px', cursor: 'pointer', opacity: 0.9 }}>
        <input type="checkbox" checked={fine} onChange={(e) => setFine(e.target.checked)} />
        fine steps
      </label>
      <button style={{ ...btn, width: '100%', background: copied ? '#9dff7d' : 'rgba(125,211,255,0.14)', color: copied ? '#0c2c06' : '#7dd3ff', fontSize: 12 }} onClick={copy}>
        {copied ? '✓ copied' : 'copy values'}
      </button>
    </div>
  );
}
